/* istanbul ignore file */

export const SNACKBAR_CONSTANTS = {
    CONTACT_SUPPORT_ERROR: 'Error submitting contact support request.',
    REPORT_FETCH_ERROR: 'Error getting report.',
    CLOSE: 'Close',
    SELECT_PROJECT_FROM_LIST: (projectAlias: string): string => `Please select a ${projectAlias} from the list.`,
    ITEM_ACTION_ERROR: (item: string, action: string, plural = false): string => `Error ${action} ${item}${plural ? 's' : ''}.`,
    ITEM_ACTION_SUCCESS: (item: string, action: string): string => `${item} ${action}.`,
    ITEM_DATA_SAVING: (item: string): string => `${item} is saving`,
    ITEM_DATA_SAVED: (item: string): string => `${item} saved`,
    ITEM_TOGGLE_ACTIVE: (item: string, itemName: string, active: boolean): string => `The ${item} '${itemName}' is now ${active ? 'active' : 'deactivated'}.`,
    FAILED_FIELD_VALIDATION: 'Please complete all required fields',
    PLATFORM_ADMIN_TOGGLE: (isAdmin: boolean): string => `The user is ${isAdmin ? " now a Platform Admin" : "no longer a Platform Admin"}.`,
    PLATFORM_ADMIN_ERROR: 'Error setting the user as a Platform Admin.',
    ACCOUNT_APPROVER_TOGGLE: (isApprover: boolean): string => `The user is ${isApprover ? " now an Account Approver" : "no longer an Account Approver"}.`,
    ACCOUNT_APPROVER_ERROR: 'Error setting the user as an Account Approver.',
    LINK_COPIED: 'Link copied to clipboard.',
    PLACEHOLDER_COPIED: 'Field placeholder copied to clipboard',
    SITE_INACTIVE_ERROR: (siteAlias: string, siteName: string): string => `The ${siteAlias} ${siteName} is Inactive: Fields are not editable for Inactive ${siteAlias}`,
    FIELD_AUTO_UPDATE_ERROR: (fieldName: string): string => `${fieldName} is automatically updated based on predefined rules and cannot be manually edited`,
    SMARTSHEET_FIELD_ERROR: (fieldName: string): string => `${fieldName} is a field pulled from Smartsheet and cannot be edited directly`,
    NO_EDIT_PERMISSION_ERROR: (fieldName: string): string => `You do not have permission to edit the ${fieldName} field`,
    FIELD_TYPE_NOT_EDITABLE_ERROR: (fieldType: string): string => `A ${fieldType} is not editable within a report`,
    NO_GRID_ROWS_ERROR: (gridName: string): string => `Editing is disabled because there are no rows in the ${gridName} grid.`,
    SITE_FIELD_NOT_EDITABLE_ERROR: (siteAlias: string): string => `A ${siteAlias} Field is not editable within a report`,
    REQUIRED_FIELDS_ERROR: (fields: string): string => `Please fill out all required fields: ${fields}`,
    UPDATE_REPORT_ERROR: 'Error updating report',
    REPORT_VIEW_ADDED: (name: string): string => `"${name}" has been added`,
    REPORT_VIEW_ADD_ERROR: 'Error adding report view',
    REPORT_VIEW_UPDATED: (name: string): string => `"${name}" has been updated`,
    REPORT_VIEW_UPDATE_ERROR: (name: string): string => `Error updating "${name}"`,
    REPORT_VIEW_DELETED: (name: string): string => `"${name}" has been deleted`,
    REPORT_VIEW_DELETE_ERROR: (name: string): string => `Error deleting "${name}"`,
    SITE_DATA_SAVED: (siteAlias: string): string => `${siteAlias} data saved`,
    SAVE_ERROR: 'An error has occurred while saving',
    REPORT_VIEW_ALREADY_EXISTS: (name: string): string => `A view already exist with the name: ${name}`,
    FIELD_POINT_ADDED: 'Field Point added',
    FIELD_POINT_ADD_ERROR: 'Error adding Field Point',
    FIELD_POINT_RETRIEVE_ERROR: 'Error retrieving Field Point',
    FIELD_POINT_UPDATED: 'Field Point updated',
    FIELD_POINT_UPDATE_ERROR: 'Error updating Field Point',
    NO_CHANGES_TO_SAVE: 'No changes made to save',
    BULK_USER_UPLOAD_VALIDATION: 'Please make sure the excel file contains the following headers (case sensitive) in the following order: firstName, lastName, email, cellPhone, workPhone, title, organization, region, address, userNo',
    BULK_USER_UPLOAD_NO_FILE: 'Please select a file to upload users',
    ERROR_ACTION_ITEM: (item: string, action: string): string => `Error ${action} ${item}`,
    MAP_SETTINGS_SAVED: (appName: string): string => `Map Settings for ${appName} has been saved`,
    MAP_SETTINGS_SAVE_ERROR: 'Error Updating Map Settings',
    PLEASE_FILL_NAME_FIELD: 'Please fill the name field',
    LAYOUT_DRAFT_SAVED: 'Layout draft saved',
    LAYOUT_PUBLISHED: 'Layout published',
    LAYOUT_COPIED: 'Layout copied successfully',
    LAYOUT_UPLOADED: 'Layout uploaded successfully',
    LAYOUT_EXPORT_ERROR: 'Layout export failed',
    LAYOUT_UPLOAD_ERROR: 'Layout upload failed',
    SUMMARY_PROJECT_CONFLICT: (summaryProjectAlias: string): string => `Another user has already created a ${summaryProjectAlias}. Reload the page to edit it.`,
    ITEM_UPDATED: (item: string): string => `${item} Updated`,
    ITEMS_LOADED: (items: string): string => `${items} Loaded`,
    APP_CREATED: 'App Created',
    APP_CREATE_ERROR: 'Unable to submit app request.'
};
